var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAQElEQVR42mMYBdgBY/C5M9gw0ZoZLCZgxSA54jVr5iNj4gwBSyI0Y2KEAWk0NQAfJmwAAYwwAA9IIwaPJnYEAAC4THC5xdMKWAAAAABJRU5ErkJggg==";
  export default img;